import styled from "styled-components";

export const ExplorerOnboardingTooltipTitleContainerBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .explorer-menu-onboarding-title-text {
    font-size: 2.5rem;
    font-weight: 700;
    padding: 0 1rem;
  }

  .explorer-menu-onboarding-title-new-box {
    background-color: ${props => props.theme.colors.exploreHighlight};
    border-radius: 16px;
    padding: 2px 8px;
    font-size: 1.5rem;
    text-align: center;
    height: fit-content;
  }
`;